module.exports = "/_next/static/images/06fa139e1070761f851dc898ccdb08f4-icon-2.svg.webp";